








import 'reflect-metadata'
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class BreadcrumbsPath extends Vue { 
	@Prop(String) public text1!: string
	@Prop(String) public text2!: string

	breadcrumbs: any = []

	created () {
		this.breadcrumbs = [
			{ text: this.text1 },
			{ text: this.text2 }
		]
	}
	
}
